import { Loader } from "@/components/Loader/Loader.tsx";
import { useEffect, useState } from "react";

interface OverlayProps {
  duration?: number;
  onComplete?: () => void;
}

export const PaymentRedirectOverlay = ({ duration = 5000, onComplete }: OverlayProps) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onComplete?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onComplete]);

  // hide scroll on app whilst overlay active
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="redirection-wrap">
      <main className="resOverviewWrap o-page">
        <div className="o-page__inner">
          <section className="c-reservation-overview-wrapper">
            <div className="c-reservation-overview">
              <div className="c-reservation-overview__info">
                <Loader loading />
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};
